import { useEffect, useRef, useState } from 'react'
import placeholders from '../../PLACEHOLDERS.json'
import searchIcon from '../../icons/search.svg'
import './SearchForm.scss'
import { useLocation, useNavigate } from 'react-router-dom'

export default function SearchForm() {
	const navigate = useNavigate()
	const location = useLocation()
	const [query, setQuery] = useState('')
	const [placeholder, setPlaceholder] = useState('')
	const index = useRef(0)
	const letter = useRef(0)
	const typingInterval = useRef(null)

	useEffect(() => {
		startTyping()
		return () => clearInterval(typingInterval.current)
	}, [])

	const startTyping = () => {
		clearInterval(typingInterval.current)
		letter.current = 0
		setPlaceholder('')
		const word = placeholders[index.current]

		typingInterval.current = setInterval(() => {
			if (letter.current <= word.length) {
				setPlaceholder(word.slice(0, letter.current))
				letter.current++
			} else {
				clearInterval(typingInterval.current)
				setTimeout(() => {
					index.current = (index.current + 1) % placeholders.length
					startTyping()
				}, 1500)
			}
		}, 100)
	}

	const onSearch = () => {
		const value = query.toLowerCase().trim()
		if (value) {
			setQuery('')
			navigate(`/${encodeURIComponent(value)}`)
		} else if (location.pathname !== '/') {
			navigate('/')
		}
	}

	const handleOnChange = e => {
		const value = e.target.value.toLowerCase()

		setQuery(value)
	}

	return (
		<div className='search-form'>
			<h2 className='search-form__title'>Kolir чого завгодно</h2>
			<div className='search-form__input-wrapper'>
				<img
					src={searchIcon}
					alt='search-form__icon'
					className='search-form__icon'
				/>
				<input
					type='text'
					className='search-form__input'
					value={query}
					onChange={handleOnChange}
					placeholder={placeholder}
					onKeyDown={e => {
						if (e.key === 'Enter') onSearch()
					}}
				/>
			</div>
		</div>
	)
}
